import { Navigate } from "react-router-dom";
import useAuth from "../auth/useAuth";
import tokenService from "../auth/tokenService";

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <span>Loading...</span>
      </div>
    );
  }

  // Already logged in → redirect away from /login
  if (user || tokenService.hasRefreshToken()) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;